/**
 * SEO Performance Boost Script
 * تحسين الأداء والسرعة لمحركات البحث
 * بدون تأثير على الروابط أو الوظائف الأساسية
 */

(function() {
    'use strict';

    // تحسين تحميل الصور (Lazy Loading)
    function initLazyLoading() {
        if ('IntersectionObserver' in window) {
            const imageObserver = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const img = entry.target;
                        if (img.dataset.src) {
                            img.src = img.dataset.src;
                            img.removeAttribute('data-src');
                            img.classList.remove('lazy');
                            observer.unobserve(img);
                        }
                    }
                });
            });

            document.querySelectorAll('img[data-src]').forEach(img => {
                imageObserver.observe(img);
            });
        }
    }

    // تحسين الخطوط (Font Loading)
    function optimizeFontLoading() {
        if ('fonts' in document) {
            // تحميل الخطوط المهمة أولاً
            const criticalFonts = [
                'Arial',
                'Helvetica',
                'sans-serif'
            ];

            criticalFonts.forEach(font => {
                if (document.fonts.check(`16px ${font}`)) {
                    document.documentElement.classList.add('fonts-loaded');
                }
            });
        }
    }

    // تحسين Core Web Vitals
    function optimizeCoreWebVitals() {
        // تحسين Cumulative Layout Shift (CLS)
        const images = document.querySelectorAll('img:not([width]):not([height])');
        images.forEach(img => {
            if (!img.style.aspectRatio && !img.width && !img.height) {
                img.style.aspectRatio = '16/9'; // نسبة افتراضية
            }
        });

        // تحسين First Input Delay (FID)
        const deferredScripts = document.querySelectorAll('script[data-defer]');
        deferredScripts.forEach(script => {
            script.defer = true;
        });
    }

    // تحسين تحميل الموارد
    function optimizeResourceLoading() {
        // إضافة preload للموارد المهمة
        const criticalResources = [
            { href: '/assets/base.css', as: 'style' },
            { href: '/assets/global.js', as: 'script' }
        ];

        criticalResources.forEach(resource => {
            const link = document.createElement('link');
            link.rel = 'preload';
            link.href = resource.href;
            link.as = resource.as;
            if (resource.as === 'style') {
                link.onload = function() {
                    this.onload = null;
                    this.rel = 'stylesheet';
                };
            }
            document.head.appendChild(link);
        });
    }

    // تحسين التخزين المؤقت
    function optimizeCaching() {
        // تخزين البيانات المهمة في localStorage
        const cacheVersion = '1.0.0';
        const currentVersion = localStorage.getItem('seo-cache-version');
        
        if (currentVersion !== cacheVersion) {
            localStorage.clear();
            localStorage.setItem('seo-cache-version', cacheVersion);
        }
    }

    // تحسين الأداء للأجهزة المحمولة
    function optimizeMobilePerformance() {
        if (window.innerWidth <= 768) {
            // تقليل جودة الصور للأجهزة المحمولة
            const images = document.querySelectorAll('img');
            images.forEach(img => {
                if (img.src && img.src.includes('cdn.shop')) {
                    const url = new URL(img.src);
                    if (!url.searchParams.has('width')) {
                        url.searchParams.set('width', '400');
                        img.src = url.toString();
                    }
                }
            });

            // تأجيل تحميل المحتوى غير المهم
            const nonCriticalElements = document.querySelectorAll('.non-critical');
            nonCriticalElements.forEach(element => {
                element.style.display = 'none';
                setTimeout(() => {
                    element.style.display = '';
                }, 2000);
            });
        }
    }

    // مراقبة الأداء
    function monitorPerformance() {
        if ('PerformanceObserver' in window) {
            // مراقبة Core Web Vitals
            const observer = new PerformanceObserver((list) => {
                list.getEntries().forEach((entry) => {
                    if (entry.entryType === 'largest-contentful-paint') {
                        console.log('LCP:', entry.startTime);
                    }
                    if (entry.entryType === 'first-input') {
                        console.log('FID:', entry.processingStart - entry.startTime);
                    }
                    if (entry.entryType === 'layout-shift') {
                        if (!entry.hadRecentInput) {
                            console.log('CLS:', entry.value);
                        }
                    }
                });
            });

            observer.observe({ entryTypes: ['largest-contentful-paint', 'first-input', 'layout-shift'] });
        }
    }

    // تحسين SEO التقني
    function optimizeTechnicalSEO() {
        // إضافة structured data للصفحة الحالية
        const currentPage = window.location.pathname;
        
        if (currentPage.includes('/products/')) {
            // إضافة Product Schema (سيتم تطبيقه في ملف منفصل)
            console.log('Product page detected - Schema will be added separately');
        }

        // تحسين meta tags ديناميكياً
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription && metaDescription.content.length < 120) {
            // الوصف قصير جداً - سيتم تحسينه في ملفات القالب
            console.log('Meta description needs optimization');
        }

        // تحسين العناوين
        const h1Elements = document.querySelectorAll('h1');
        if (h1Elements.length === 0) {
            console.log('Missing H1 tag - needs to be added');
        } else if (h1Elements.length > 1) {
            console.log('Multiple H1 tags found - needs optimization');
        }
    }

    // تشغيل جميع التحسينات
    function initSEOOptimizations() {
        // تشغيل التحسينات عند تحميل الصفحة
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function() {
                initLazyLoading();
                optimizeFontLoading();
                optimizeCoreWebVitals();
                optimizeResourceLoading();
                optimizeCaching();
                optimizeMobilePerformance();
                optimizeTechnicalSEO();
                monitorPerformance();
            });
        } else {
            initLazyLoading();
            optimizeFontLoading();
            optimizeCoreWebVitals();
            optimizeResourceLoading();
            optimizeCaching();
            optimizeMobilePerformance();
            optimizeTechnicalSEO();
            monitorPerformance();
        }
    }

    // بدء التحسينات
    initSEOOptimizations();

    // تصدير الوظائف للاستخدام الخارجي
    window.SEOPerformanceBoost = {
        initLazyLoading,
        optimizeFontLoading,
        optimizeCoreWebVitals,
        optimizeResourceLoading,
        optimizeCaching,
        optimizeMobilePerformance,
        optimizeTechnicalSEO,
        monitorPerformance
    };

})();

